module.exports = __webpack_public_path__ + "media/images/guide-7t-398ae4a956d1fe9d6c22e7e5dea48ed1.png";